var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "nav company",
      class: _vm.isOpen && "is-open",
      style: _vm.dropdownStyles,
      attrs: { "data-id": "company" }
    },
    [
      _c(
        "button",
        {
          staticClass: "company__btn",
          attrs: { id: "companyselected", title: _vm.selectedCompanyHoverText },
          on: { click: _vm.toogleList }
        },
        [
          _vm._m(0),
          _c(
            "span",
            {
              staticClass: "company__name",
              attrs: { "data-id": "company-name" }
            },
            [_vm._v(_vm._s(_vm.selectedCompanyName))]
          ),
          _vm.selectedCompanyNumber
            ? _c(
                "span",
                {
                  staticClass: "company__number",
                  attrs: { "data-id": "company-number" }
                },
                [_vm._v(_vm._s(`(${_vm.selectedCompanyNumber})`))]
              )
            : _vm._e(),
          _vm._m(1)
        ]
      ),
      _vm.isOpen
        ? _c(
            "ul",
            { staticClass: "company__menu", attrs: { id: "companylist" } },
            _vm._l(_vm.companies.items, function(company) {
              return _c(
                "li",
                {
                  key: company.id,
                  class: [
                    "company__menu-item",
                    company.id == _vm.activeCompanyId ? "is-active" : ""
                  ],
                  attrs: { id: `company_${company.id}` },
                  on: {
                    click: function($event) {
                      return _vm.changeCompany(company)
                    }
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "company__menu-item-link",
                      attrs: { href: `/?cid=${company.id}`, tabindex: "0" },
                      on: { click: _vm.onLinkClick }
                    },
                    [
                      _c("span", {
                        staticClass: "company__color-badge",
                        style: _vm.itemStyle(company)
                      }),
                      _c("span", { staticClass: "company__menu-link" }, [
                        _vm._v(
                          " " +
                            _vm._s(company.companyName) +
                            " " +
                            _vm._s(`(${company.companyNumber})`) +
                            " "
                        )
                      ])
                    ]
                  )
                ]
              )
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "company__icon" }, [
      _c("i", { staticClass: "icon icon-company" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "company__expand-icon" }, [
      _c("i", { staticClass: "icon icon-arrow_down_filled" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }